import { cloneDeep, isEmpty } from 'lodash'

import { getCustomerData, getIndianStates } from 'api'

import {
  childDataColumn,
  groupKeys,
  noHeadingList
} from './components/shared/config'
import { batchTypes, navigationPaths } from './config'
import { USER_STATUS } from './constants'
import { isNullOrEmpty, isNullOrEmptyLodash } from './helpers'

const parentCustomerData = async () => {
  return await getCustomerData('CUSTOMER_DATA_PARENT')
}

const studentCustomerData = async () => {
  return await getCustomerData('CUSTOMER_DATA_STUDENT')
}

export const parentDataTransformer = async (selectedParentDetails) => {
  const customerParentData = await parentCustomerData()

  const { data: indianStates } = await getIndianStates()

  const statesMap = {}
  indianStates.forEach((state) => {
    statesMap[state[0]] = state[1]
  })

  const parentData = {
    parentId: selectedParentDetails?.user?.uuid,
    parentName: `${selectedParentDetails?.user?.first_name} ${selectedParentDetails?.user?.last_name}`,
    parentMobileNumber: selectedParentDetails?.user?.phone_number,
    prefferedCentre: selectedParentDetails?.centre
      ? selectedParentDetails?.centre?.name
      : selectedParentDetails?.centre_preference
      ? selectedParentDetails?.centre_preference?.name
      : 'NA'
  }

  let parentBasicData = []

  if (!isEmpty(selectedParentDetails)) {
    parentBasicData = [
      {
        key: 'STATE',
        display_text: 'state',
        response: selectedParentDetails?.user?.state
          ? statesMap[selectedParentDetails?.user?.state]
          : 'Not Available',
        showHeading: true
      },
      {
        key: 'POSTAL_CODE',
        display_text: 'postal-code',
        response: selectedParentDetails?.user?.address_detail
          ? selectedParentDetails?.user?.address_detail?.postal_code
          : 'Not Available',
        showHeading: true
      },
      {
        key: 'POSTAL_ADDRESS',
        display_text: 'postal-address',
        response: selectedParentDetails?.user?.address_detail
          ? selectedParentDetails?.user?.address_detail?.postal_address
          : 'Not Available',
        showHeading: true
      }
    ]
  }
  let parentAdditionalDetails = []
  if (
    !isEmpty(selectedParentDetails) &&
    !isEmpty(selectedParentDetails?.additional_information)
  ) {
    const parentAdditionalDetailsDispalyKeys = Object.keys(
      selectedParentDetails?.additional_information
    )

    customerParentData.map((item) => {
      if (parentAdditionalDetailsDispalyKeys.includes(item.key)) {
        parentAdditionalDetails.push(item)
      }
    })

    parentAdditionalDetails.forEach((obj, index) => {
      parentAdditionalDetails[index] = {
        ...parentAdditionalDetails[index],
        response:
          selectedParentDetails?.additional_information[obj.key] ||
          'not available',
        showHeading: true
      }
    })
  }

  const isCustomer =
    selectedParentDetails?.user?.status === USER_STATUS.CUSTOMER

  if (
    !isEmpty(selectedParentDetails) &&
    isCustomer &&
    selectedParentDetails?.user?.referral_code
  ) {
    parentAdditionalDetails.push({
      key: 'REFERRAL_CODE',
      display_text: 'Referral Code',
      type: 'text',
      response: selectedParentDetails?.user?.referral_code,
      descriptionTextTransform: 'initial',
      showHeading: true
    })
  }

  let studentAdditionalInformation = []
  if (!isEmpty(selectedParentDetails)) {
    studentAdditionalInformation = await Promise.all(
      selectedParentDetails?.students?.map((item) => {
        const childData = childCustomerDataTransformer(item)
        return childData
      })
    )
  }

  return {
    parentData,
    parentBasicData,
    parentAdditionalDetails,
    studentAdditionalInformation
  }
}

export const childCustomerDataTransformer = async (selectedStudent) => {
  const customerStudentData = await studentCustomerData()
  let studentAdditionalInformation = cloneDeep(customerStudentData)
  let childConfigData = {
    studentName: selectedStudent?.user?.full_name,
    id: selectedStudent?.user?.uuid
  }
  if (
    !isEmpty(selectedStudent) &&
    !isEmpty(selectedStudent?.additional_information)
  ) {
    studentAdditionalInformation.forEach((obj, index) => {
      studentAdditionalInformation[index] = {
        ...studentAdditionalInformation[index],
        response:
          selectedStudent?.additional_information[obj.key] || 'not available',
        showHeading: !noHeadingList.includes(obj.key)
      }
    })

    let configData = cloneDeep(childDataColumn)

    studentAdditionalInformation.forEach((obj) => {
      configData[groupKeys[obj.key]].data.push(obj)
    })

    childConfigData = {
      ...childConfigData,
      additionalData: studentAdditionalInformation,
      configData: Object.values(configData)
    }
  }
  return childConfigData
}

export const studentsParentBasicDetailsTransformer = (
  selectedParentDetails,
  states
) => {
  return [
    {
      key: 'PARENT_NAME',
      display_text: 'parent name',
      response: selectedParentDetails?.user
        ? `${selectedParentDetails?.user?.first_name} ${selectedParentDetails?.user?.last_name}`
        : 'Not Available',
      showHeading: true,
      parentUrl: `${navigationPaths.parentdashboard}?parent=${selectedParentDetails?.user_id}`
    },
    {
      key: 'PARENT_NUMBER',
      display_text: 'parent number',
      response: selectedParentDetails?.user
        ? selectedParentDetails?.user?.phone_number
        : 'Not Available',
      showHeading: true
    },
    {
      key: 'STATE',
      display_text: 'state',
      response: selectedParentDetails?.user
        ? states[selectedParentDetails?.user?.state]
        : 'not available',
      showHeading: true
    },
    {
      key: 'CENTRE',
      display_text: 'centre',
      response: selectedParentDetails?.centre
        ? selectedParentDetails?.centre?.name
        : selectedParentDetails?.centre_preference
        ? selectedParentDetails?.centre_preference?.name
        : 'not available',
      showHeading: true
    }
  ]
}

export const batchDataTransformer = (batchData) => {
  const data = batchData?.data.map((batch) => {
    let teacher_name = null

    if (batch.type === batchTypes.exploration && batch.batch_activities) {
      teacher_name = batch.batch_activities.reduce(
        (prev, curr, currIndex) =>
          (prev += curr?.teacher?.user?.full_name
            ? (currIndex > 0 ? ', ' : '') + curr?.teacher?.user?.full_name
            : ''),
        ''
      )
    } else if (batch.teacher) {
      teacher_name = batch.teacher.user.full_name
    }

    return {
      teacher_name,
      ...batch
    }
  })

  return {
    ...batchData,
    data
  }
}

export const interactionDataTransformer = (interactionData) => {
  const results = interactionData?.results

  const transformedResults = results.map((interaction) => {
    return {
      ...interaction,
      interaction_topics_list: Array.isArray(interaction?.interaction_topics)
        ? interaction?.interaction_topics?.map((topic) => topic?.topic)
        : [],
      centre: {
        name: interaction.parent?.centre_preference?.name,
        uuid: interaction.parent?.centre_preference?.uuid
      },
      parent_full_name: interaction.parent?.user?.full_name,
      parent_phone_number: interaction.parent?.user?.phone_number
    }
  })

  const data = {
    ...interactionData,
    results: transformedResults
  }
  return data
}

export const ticketDataTransformer = (ticketData) => {
  const results = ticketData?.results

  const transformedResults = results.map((ticket) => {
    return {
      ...ticket,
      user: { user: ticket?.user },
      centre: {
        name: ticket?.centre?.name,
        uuid: ticket?.centre?.uuid
      },
      user_full_name: ticket?.user?.full_name,
      user_phone_number: ticket?.user?.phone_number,
      user_type: ticket?.user?.is_customer,
      // Ensure intent fields are properly passed through
      conversion_intent: ticket?.conversion_intent,
      interested_programs: ticket?.interested_programs,
      tentative_joining_date: ticket?.tentative_joining_date,
      intent_reason: ticket?.intent_reason
    }
  })

  const transformedData = {
    ...ticketData,
    results: transformedResults
  }
  return transformedData
}

export const announcementDataTransformer = (announcementData) => {
  const results = announcementData?.results
  const transformedResults = results.map((announcement) => {
    const isMiscellaneous = announcement.type === 'General'
    return {
      ...announcement,
      event_start_date: announcement?.timings?.start_date ?? null,
      event_end_date: announcement?.timings?.end_date ?? null,
      event_start_time: announcement?.timings?.start_time ?? null,
      event_end_time: announcement?.timings?.end_time ?? null,
      isMiscellaneous,
      tag_1: announcement?.tags?.tagsList?.[0] ?? null,
      tag_2: announcement?.tags?.tagsList?.[1] ?? null
    }
  })

  const transformedData = {
    ...announcementData,
    results: transformedResults
  }
  return transformedData
}

export const announcementDataStructure = (announcementFormData) => {
  const isMiscellaneous = announcementFormData?.type === 'General'

  let announcementStructure = {
    type: announcementFormData?.type,
    title: announcementFormData?.title,
    description: announcementFormData?.description,
    centres: announcementFormData?.centres?.map((centre) =>
      centre?.uuid ? centre.uuid : centre
    ),
    subtype: announcementFormData?.subtype,
    image: announcementFormData?.image,
    start_date: announcementFormData?.start_date,
    end_date: announcementFormData?.end_date
  }

  if (announcementFormData?.is_cta_present) {
    if (!isNullOrEmptyLodash(announcementFormData?.cta)) {
      announcementStructure.cta = announcementFormData.cta
    } else {
      announcementStructure.cta = null
    }

    if (!isNullOrEmptyLodash(announcementFormData?.cta_link)) {
      announcementStructure.cta_link = announcementFormData.cta_link
    } else {
      announcementStructure.cta = null
    }
  } else {
    announcementStructure.cta_link = null
    announcementStructure.cta = null
  }

  console.log(announcementFormData, 'announcement')
  if (isMiscellaneous) {
    // Handle tags as tagsList array
    const tag_1 = !isNullOrEmpty(announcementFormData?.tag_1)
      ? announcementFormData.tag_1
      : null
    const tag_2 = !isNullOrEmpty(announcementFormData?.tag_2)
      ? announcementFormData.tag_2
      : null

    const tagsList = [tag_1, tag_2].filter((tag) => tag !== null)
    announcementStructure.tags = {
      tagsList: tagsList
    }

    // Create timings object
    announcementStructure.timings = {
      start_date: announcementFormData?.event_start_date || null,
      end_date: announcementFormData?.event_end_date || null,
      start_time: announcementFormData?.event_start_time || null,
      end_time: announcementFormData?.event_end_time || null
    }
  } else {
    if (!isNullOrEmptyLodash(announcementFormData?.batch_type)) {
      announcementStructure.batch_type = announcementFormData.batch_type?.uuid
        ? announcementFormData.batch_type.uuid
        : announcementFormData.batch_type
    } else {
      announcementStructure.batch_type = null
    }

    if (!isNullOrEmptyLodash(announcementFormData?.subject)) {
      announcementStructure.subject = announcementFormData.subject?.uuid
        ? announcementFormData.subject.uuid
        : announcementFormData.subject
    } else {
      announcementStructure.subject = null
    }
  }

  return announcementStructure
}
